import { baseSplitApi } from "../baseApi";

const employeesAuthBasePath = "/auth/employee"
const addEmployeePath = `${employeesAuthBasePath}/signup`
const EMPLOYEE_TAG = "employee_tag"
const updateEmployeeDetailsPath = `${employeesAuthBasePath}/update_employee_details`
const deleteEmployeeDetailsPath = `${employeesAuthBasePath}/delete_employee_details`

export const employeeCenterAPI = baseSplitApi.injectEndpoints({
    endpoints: (build) => ({
        getAllEmployees: build.query({
            query: () => {
                return {
                    url: employeesAuthBasePath
                }
            },
            providesTags:[EMPLOYEE_TAG]
        }),
        addEmployee : build.mutation({
            query: (body) => {
                return {
                    url: addEmployeePath,
                    method: 'POST',
                    body
                }
            },
            invalidatesTags:[EMPLOYEE_TAG]
        }),
        updateEmployeeDetails: build.mutation({
            query: (body) => {
                return {
                    url: `${updateEmployeeDetailsPath}?uniqueID=${body._id}`,
                    method: 'PUT',
                    body
                }
            },
            invalidatesTags:[EMPLOYEE_TAG]
        }),
        deleteEmployeeDetails: build.mutation({
            query: (uniqueID) => {
                return {
                    url: `${deleteEmployeeDetailsPath}?uniqueID=${uniqueID}`,
                    method:"DELETE"
                }
            },
            invalidatesTags:[EMPLOYEE_TAG]
        })
    })
})


export const { useGetAllEmployeesQuery, useAddEmployeeMutation, useUpdateEmployeeDetailsMutation, useDeleteEmployeeDetailsMutation } = employeeCenterAPI